import { styled } from "@mui/material";
import Component from "./component";

export default styled(Component)(({ theme }) => ({
  display: "flex",
  height: "inherit",
  justifyContent: "center",
  width: "100%",
  backgroundImage: "url(/assets/images/background1.png)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  // background:
  //     "linear-gradient(0deg, #0C56BC 0%, #0C56BC 100%), url(/assets/images/background1.png), #eee 50% / cover no-repeat",
  // backgroundBlendMode: "color,overlay",

  ".form-cont": {
    width: 600,
    marginTop: 150,
    h4: {
      fontWeight: "bold",
    },
  },
  ".auth-form": {
    textAlign: "center",
    border: "1px solid #e0e0e0",
    height: "fit-content",
    borderRadius: 10,
    marginTop: 20,
    padding: 20,
    backgroundColor: "#fff",
  },
  ".MuiTabs-root": {
    borderBottom: "1px solid #e0e0e0",
  },
  ".MuiTabs-flexContainer": {
    justifyContent: "left",
  },
  "& .MuiTextField-root": {
    margin: 8,
  },
  ".MuiButton-contained": {
    margin: theme.spacing(1),
  },
}));
